import storage from "../../common/storage";
import anlysisConstants from "./anlysisConstants";
import Utils from "../../utils/utils";

export default {
  redirect2Index: function () {
    let roleCode = storage.getSessionStorage("role");
    if (
      roleCode === anlysisConstants.roleType.teacher ||
      roleCode === anlysisConstants.roleType.school ||
      roleCode === anlysisConstants.roleType.district
    ) {
      this.redirect2Analysis();
    } else if (
      roleCode === anlysisConstants.roleType.cityInstructor ||
      roleCode === anlysisConstants.roleType.proInstructor
    ) {
      this.redirect2Analysis();
    } else if (roleCode === anlysisConstants.roleType.student) {
      window.location.href = "stuindex.html";
    } else {
      window.location.href = "login.html";
    }
  },
  //跳转到考务管理系统
  redirect2Exam: function () {
    let roleCode = storage.getSessionStorage("role");
    if (roleCode === anlysisConstants.roleType.teacher) {
      window.location.href = "exam.html";
    } else if (roleCode === anlysisConstants.roleType.school) {
      window.location.href = "mock.html";
    } else if (roleCode === anlysisConstants.roleType.district) {
      window.location.href = "plan.html";
    }else if (roleCode === anlysisConstants.roleType.cityInstructor) {
      window.location.href = "cityplan.html";
    }else if (roleCode === anlysisConstants.roleType.proInstructor) {
      window.location.href = "prolevelplan.html";
    }  else {
      window.location.href = "";
    }
  },

  // 跳转到备练习管理页面
  redirect2Practive: function () {
    window.location.href = "practive.html";
    console.log("window.location.href", window.location.href);
  },
  //跳转到考务管理首页
  redirect2ExamIndex: function () {
    let roleCode = storage.getSessionStorage("role");
    if (roleCode === anlysisConstants.roleType.teacher) {
      window.location.href = "teaindex.html";
    } else if (roleCode === anlysisConstants.roleType.school) {
      window.location.href = "subindex.html";
    } else if (roleCode === anlysisConstants.roleType.district) {
      window.location.href = "insindex.html";
    } else if (roleCode === anlysisConstants.roleType.student) {
      window.location.href = "stuindex.html";
    } else {
      window.location.href = "";
    }
  },
  //跳转到学习分析页面
  redirect2Analysis: function (roleCode, params) {
    let userInfo = JSON.parse(storage.getSessionStorage("user"));
    roleCode = roleCode || storage.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    let htmlName = "login.html";
    switch (roleCode) {
      case anlysisConstants.roleType.school: //学校概况
        htmlName = "schoolLearnInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
        };
        break;
      case anlysisConstants.roleType.district: //区县概况
        htmlName = "districtLearnInfo.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode,
        };
        break;
      case anlysisConstants.roleType.cityInstructor: //市级概况
        htmlName = "cityplan.html";
        params = params || {
          cityName: userInfo.cityName,
          cityCode: userInfo.cityCode,
        };
        break;
      case anlysisConstants.roleType.proInstructor: //省级概况
        // htmlName = "provinceLearnInfo.html";
        htmlName = "prolevelplan.html"
        params = params || {
          provinceName: userInfo.provinceName,
          provinceCode: userInfo.provinceCode,
        };
        break;
      case anlysisConstants.roleType.grade: //年级概况
        htmlName = "gradeLearnInfo.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode,
        };
        break;
      case anlysisConstants.roleType.class: //班级详情
      case anlysisConstants.roleType.teacher:
        htmlName = "classLearnInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析页面
  redirect2ExamAnalysis: function (roleCode, params) {
    let userInfo = JSON.parse(storage.getSessionStorage("user"));
    roleCode = roleCode || storage.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    let htmlName = "login.html";
    switch (roleCode) {
      case anlysisConstants.roleType.school: //学校概况
        htmlName = "schoolExamInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
        };
        break;
      case anlysisConstants.roleType.district: //区县概况
        htmlName = "districtExamInfo.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode,
        };
        break;
      case anlysisConstants.roleType.grade: //年级概况
        htmlName = "gradeExamInfo.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode,
        };
        break;
      case anlysisConstants.roleType.class: //班级详情
      case anlysisConstants.roleType.teacher:
        htmlName = "classExamInfo.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
          className: userInfo.className,
          classId: userInfo.classId,
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode,
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析单次报告页面
  redirect2SingleExamReport: function (roleCode, params) {

    let userInfo = JSON.parse(storage.getSessionStorage("user"));
    roleCode = roleCode || storage.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    let htmlName = "login.html";
    switch (roleCode) {
      case anlysisConstants.roleType.school: //学校单次报告
        htmlName = "schoolSingleExamReport.html";
        params = params || {
          schoolName: userInfo.schoolName,
          schoolId: userInfo.schoolId,
        };
        break;
      case anlysisConstants.roleType.district: //区县单次报告
        htmlName = "districtSingleExamReport.html";
        params = params || {
          districtName: userInfo.districtName,
          districtCode: userInfo.districtCode,
        };
        break;
      case anlysisConstants.roleType.cityInstructor: //市级单次报告
        htmlName = "citySingleExamReport.html";
        params = params || {
          planCityName: userInfo.planCityName,
          cityCode: userInfo.cityCode,
        };
        break;
        case anlysisConstants.roleType.proInstructor: //省级单次报告
        htmlName = "proSingleExamReport.html";
        params = params || {
          planCityName: userInfo.provinceName,
          cityCode: userInfo.provinceCode,
        };
        break;
      case anlysisConstants.roleType.grade: //年级单次报告
        htmlName = "gradeSingleExamReport.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode,
        };
        break;
      case anlysisConstants.roleType.class: //班级单次报告
      case anlysisConstants.roleType.teacher:
        htmlName = "classSingleExamReport.html";
        params = params || {
          className: userInfo.className,
          classId: userInfo.classId,
        };
        break;
      case anlysisConstants.roleType.student: //学生个人报告
        htmlName = "studentExamReport.html";
        params = params || {
          studentName: userInfo.studentName,
          studentId: userInfo.studentId,
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  //跳转到考务分析历次成绩页面
  redirect2PreviousScoreReport: function (roleCode, params) {
    let userInfo = JSON.parse(storage.getSessionStorage("user"));
    roleCode = roleCode || storage.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    let htmlName = "login.html";
    switch (roleCode) {
      case anlysisConstants.roleType.student: //学生历次成绩
        htmlName = "studentAllPreviousScoreReport.html";
        params = params || {
          studentName: userInfo.studentName,
          studentId: userInfo.studentId,
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  //跳转到统计分析页面
  redirect2Statistics: function (roleCode, params) {
    let userInfo = JSON.parse(storage.getSessionStorage("user"));
    roleCode = roleCode || storage.getSessionStorage("role"); //若参数中没有跳转到的角色页面，则默认跳到对应用户当前角色的页面
    let htmlName = "login.html";
    switch (roleCode) {
      case anlysisConstants.roleType.grade: //年级统计分析
        htmlName = "gradeStatistics.html";
        params = params || {
          gradeName: userInfo.gradeName,
          gradeCode: userInfo.gradeCode,
        };
        break;
      case anlysisConstants.roleType.class: //班级统计分析
        htmlName = "classStatistics.html";
        params = params || {
          className: userInfo.className,
          classId: userInfo.classId,
        };
        break;
      default:
        htmlName = "";
        break;
    }
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  //跳转到学习报告页面
  redirect2LearnReport: function (type, params) {
    if (!params) {
      //没有参数，错误
      window.location.href = "";
    }
    let htmlName = "login.html";
    switch (type) {
      case anlysisConstants.learnReportType.basicLearning: //基础学习
        htmlName = "stuBaseLearn.html";
        break;
      case anlysisConstants.learnReportType.bookSync: //课本同步
        htmlName = "stuTextbookLearn.html";
        break;
      case anlysisConstants.learnReportType.topicExpr: //话题表述
        htmlName = "stuTopicExpress.html";
        break;
      default:
        htmlName = "";
        break;
    }
    window.open(Utils.encodeBase64Params(params, htmlName));
  },
  redirect2Usercenter: function () {
    let roleCode = storage.getSessionStorage("role");
    if (roleCode === anlysisConstants.roleType.teacher) {
      window.location.href = "usercenter.html";
    } else if (roleCode === anlysisConstants.roleType.school) {
      window.location.href = "usercenter.html";
    } else if (roleCode === anlysisConstants.roleType.district) {
      window.location.href = "usercenter.html";
    } else if (roleCode === anlysisConstants.roleType.cityInstructor) {
      window.location.href = "usercenter.html";
    } else if (roleCode === anlysisConstants.roleType.proInstructor) {
      window.location.href = "usercenter.html";
    } else if (roleCode === anlysisConstants.roleType.student) {
      window.location.href = "stuusercenter.html";
    }else{}
  },
  redirect2Notice: function () {
    let roleCode = storage.getSessionStorage("role");
    if (roleCode == anlysisConstants.roleType.student) {
      window.location.href = "stunoticemanagement.html";
    } else {
      window.location.href = "noticemanagement.html";
    }
  },
  redirect2Management: function () {
    let roleCode = storage.getSessionStorage("role");
    if (roleCode === anlysisConstants.roleType.teacher) {
      window.location.href = "classmanagement.html";
    } else if (roleCode === anlysisConstants.roleType.school) {
      window.location.href = "schoolmanagement.html";
    } else if (roleCode === anlysisConstants.roleType.district) {
      window.location.href = "districtmanagement.html";
    }else{}
  },
  // 跳转到创建备练习页面
  redirectAddPiactive (params) {
    let htmlName = "addPractive.html";
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
  // 跳转到备练习预览页面
  redirectPreviewPiactive (params) {
    let htmlName = "previewPractive.html";
    window.location.href = Utils.encodeBase64Params(params, htmlName);
  },
};



// WEBPACK FOOTER //
// ./src/js/analysis/analysisRedirect.js